import React from 'react';

interface WindowProps {
  width: number;
  height: number;
}

export default function useWindowSize(): WindowProps {
  const [windowSize, setWindowSize] = React.useState<WindowProps>({
    width: 0,
    height: 0,
  });

  React.useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}
